module.exports = __webpack_public_path__ + "media/images/common/post_kuchikomi_btn_s_ov-1bf35ee42058d1f88484a397e51e2d37.png";